<template>
    <!-- <div>
        <v-text-field
            v-model="edittingDate"
            :label="label"
            :prepend-icon="icon"
            readonly
            outlined
            clearable
            :dense="dense"
            @click="showDialog()"
            @click:clear="onChangedDate" />
        <v-dialog
            ref="dialog"
            v-model="isView"
            width="290px">
            <v-date-picker v-model="edittingDate" scrollable no-title @click:date="isView = false" @change="onChangedDate">
            </v-date-picker>
        </v-dialog>
    </div> -->

        <v-menu v-if="canEdit" offset-y close-on-content-click min-width="290" max-width="290">
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="edittingDate"
                    :label="label"
                    :prepend-icon="icon"
                    :readonly="true"
                    outlined
                    :clearable="clearable"
                    :dense="dense"
                    v-on="on"
                    hide-details
                    @click:clear="onChangedDate" />
            </template>
            <v-date-picker v-model="edittingDate" scrollable no-title @change="onChangedDate" :max="max" locale="ja" :day-format="date => new Date(date).getDate()" />
        </v-menu>
        <v-text-field
            v-else
            v-model="edittingDate"
            :label="label"
            :prepend-icon="icon"
            :readonly="true"
            outlined
            :clearable="clearable"
            :dense="dense"
            v-on="on"
            hide-details />
</template>

<script>
    export default {
        props: {
            label: String,
            value: String,
            canEdit: {
                type: Boolean,
                default: true
            },
            icon: {
                type: String,
                default: "mdi-calendar"
            },
            dense: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            max: {
                type: String,
                default: undefined
            }
        },
        data: function () {
            return {
                isView: false,
            }
        },
        computed: {
            edittingDate: {
                get: function() {return this.$props.value},
                set: function(v) {
                    if (v == null) {
                        v = ""
                    }
                    this.$emit("input", v)
                }
            }
        },
        methods: {
            onChangedDate: function () {
                console.log("onChangedDate")
                this.$emit("change", this.edittingDate)
            },
            showDialog: function () {
                if (this.readOnly == true) {
                    return
                }
                this.isView = true
            },            
        }
    }
</script>
